import { useState } from "react";

import AuthorizationModal from "./AuthorizationModal";
import PreAnalysisModal from "./PreAnalysisModal";

interface CrefazCltModalProps {
  onBack: () => void;
  onClose?: () => void;
}

export default function CrefazCltModal({
  onBack,
  onClose,
}: CrefazCltModalProps) {
  const [step, setStep] = useState<"preAnalysis" | "authorization">(
    "preAnalysis",
  );

  if (step === "preAnalysis") {
    return (
      <PreAnalysisModal
        onBack={onBack}
        onContinue={() => setStep("authorization")}
      />
    );
  }

  return <AuthorizationModal onClose={onClose || onBack} />;
}
